import {
  patchRoutineDefaultValues,
  syncBQRoutines,
  generateCampaign,
} from 'services/acg/phase-1';
import {
  showErrorNotification,
  showSuccessNotification,
} from 'services/common';
import { useQueryClient, useMutation } from '@tanstack/react-query';

export const useSetBQRoutineDefaultValue = (routineName: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    updatedValues => patchRoutineDefaultValues(routineName, updatedValues),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([
          'listBigQueryRoutineArguments',
          routineName,
        ]);
        showSuccessNotification(`Successfully updated ${routineName} defaults`);
      },
      onError: () => {
        showErrorNotification(`Failed to update ${routineName} defaults`);
      },
    },
  );
};

export const useSyncBQRoutines = () => {
  return useMutation(() => syncBQRoutines(), {
    onSuccess: async () => {
      showSuccessNotification(`Request to sync routines sent`);
    },
    onError: () => {
      showErrorNotification(`Failed to sync routines`);
    },
  });
};

export const useGenerateCampaign = () => {
  return useMutation(
    data => generateCampaign(data.routineName, data.routineArguments),
    {
      onSuccess: async () => {
        showSuccessNotification(`Request to generate campaign sent`);
      },
      onError: () => {
        showErrorNotification(`Failed to generate campaign`);
      },
    },
  );
};
